<template>
  <NuxtPage />
</template>

<script lang="ts" setup>
import type { ReactiveHead } from '@unhead/vue';

import { useTranslatorLocale } from '~/composables/useTranslatorLocale';

import {
  usePreloadCurrencies,
  usePreloadLanguages,
} from './domains/referential';

import { eventCustom } from '~~/helpers/gtm.helper';

const runtimeConfig = useRuntimeConfig();
const i18Instance = useI18n();

useAppHistory();

onMounted(() => {
  if (process.server) {
    return;
  }

  // weglot fix, probably can be better solution
  setTimeout(() => {
    i18Instance.setLocale(useTranslatorLocale()?.locale?.value ?? 'en');
  },100);
});

const route = useRoute();
const isPreview = computed(() => route.query.draft === 'true');

const head = computed<ReactiveHead>(() => {
  const meta = [
    {
      name: 'google-site-verification',
      content: 'QFTRdQRgXFSTOfNL5wYw56SzYdbHzGPfEp7M131P0us',
    },
  ];

  if (isPreview.value) {
    meta.push(
      { name: 'robots', content: 'noindex, nofollow' },
      { name: 'googlebot', content: 'noindex, nofollow' },
    );
  }

  const script: ReactiveHead['script'] = [
    {
      async: false,
      'data-document-language': true,
      'data-domain-script': runtimeConfig.public.oneTrustToken,
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    },
    {
      async: true,
      children: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.defer=true;j.src=
          'https://sgtm.allinclusive-collection.com/ixzn81lqx6jltmk.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KBV232K');`,
    },
  ];

  if (import.meta.env.NEW_RELIC_ENABLED === 'true') {
    script.push({ src: `/newrelic.${runtimeConfig.public.appEnv}.js` });
  }

  return {
    htmlAttrs: {
      lang: i18Instance.locale.value,
    },
    script,
    meta,
  };
});

useHead(head);

useIdentificationPlaintext();

await usePreloadCurrencies();
await usePreloadLanguages();

if (route.query?.type === 'login') {
  eventCustom('Generic Event', { event_name: 'login' });
}
</script>

<style lang="scss">
@use '@/assets/styles/main';
@use '@/assets/styles/print';
</style>
